import React, { useState, forwardRef, useEffect } from "react";

import { InputText } from "primereact/inputtext";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import { InputTextarea } from "primereact/inputtextarea";
import trainingsAPI from "../../../../services/trainings";
import { Calendar } from "primereact/calendar";
import MeaButton from "../../../../components/MeaButton";
import { SplitButton } from "primereact/splitbutton";

const UpdateTrainingModal = forwardRef((props, ref) => {
  //
  //
  const [id, setId] = useState("");
  const [schoolId, setSchoolId] = useState("");
  const [status, setStatus] = useState("");
  const [name, setName] = useState("");
  const [presentation, setPresentation] = useState(null);
  const [trainingStartDate, setTrainingStartDate] = useState("");
  const [trainingEndDate, setTrainingEndDate] = useState("");
  const [registrationStartDate, setRegistrationStartDate] = useState("");
  const [registrationEndDate, setRegistrationEndDate] = useState("");
  const [internalRulesUrl, setInternalRulesUrl] = useState("");

  useEffect(() => {
    setId(props?.training?.id);
    setSchoolId(props?.training?.school_id);
    setName(props?.training?.name);
    setPresentation(props?.training?.presentation);
    setTrainingStartDate(props?.training?.start_courses_date || "");
    setTrainingEndDate(props?.training?.end_courses_date || "");
    setRegistrationStartDate(props?.training?.start_registration_date || "");
    setRegistrationEndDate(props?.training?.end_registration_date || "");
    setStatus(props?.training?.status);
    setInternalRulesUrl(props?.training?.internal_rules_url);
  }, [props]);

  const handleChangeTrainingStatus = (status) => {
    trainingsAPI.UpdateTrainingStatus(schoolId, id, props?.accessToken, {
      status: status,
    }).then((data) => {
      ref?.current?.hide();
      //console.log(props)
      props?.query?.refetch();
    }).catch((err) => {
      console.error(err);
      ref?.current?.hide();
    });
  }

  const changeStatusButtons = () => {
    const getStatusLabel = (status) => {
      switch (status) {
        case "OPEN":
          return "Ouvert";
        case "ARCHIVED":
          return "Archivé";
        case "DRAFT":
          return "Brouillon";
        default:
          return status || "Statut inconnu";
      }
    };

    return (
      <SplitButton
        label={getStatusLabel(status)}
        model={[
          {
            label: 'Ouvrir la formation',
            command: () => {
              handleChangeTrainingStatus("OPEN");
            }
          },
          {
            label: 'Archiver',
            command: () => {
              handleChangeTrainingStatus("ARCHIVED");
            }
          },
          {
            label: 'Brouillon',
            command: () => {
              handleChangeTrainingStatus("DRAFT");
            }
          }
        ]}
        outlined
      />
    )
  }
  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Editer la formation"
        id={props?.training?.id}
        accessToken={props?.accessToken}
        schoolId={props?.schoolId}
        trainingId={props?.trainingId}
        footerExtra={
          changeStatusButtons()
        }
        serviceAPI={trainingsAPI}
        data={{
          name: name,
          presentation: presentation,

          start_courses_date:
            trainingStartDate !== "" && trainingStartDate !== undefined
              ? new Date(trainingStartDate).toISOString()
              : null,
          end_courses_date:
            trainingEndDate !== "" && trainingStartDate !== trainingEndDate
              ? new Date(trainingEndDate).toISOString()
              : null,
          start_registration_date:
            registrationStartDate !== "" && registrationStartDate !== undefined
              ? new Date(registrationStartDate).toISOString()
              : null,
          end_registration_date:
            registrationEndDate !== "" && registrationStartDate !== registrationEndDate
              ? new Date(registrationEndDate).toISOString()
              : null,
          internal_rules_url: internalRulesUrl,
        }}
      >
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Nom de la formation
        </label>
        <InputText
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full mb-3"
          autoFocus
        />
        <label
          htmlFor="presentation"
          className="block text-900 font-medium mb-2"
        >
          Présentation
        </label>
        <InputTextarea
          id="presentation"
          type="text"
          value={presentation}
          onChange={(e) => setPresentation(e.target.value)}
          rows={3}
          className="w-full mb-3"
        />
        <div className="grid formgrid p-fluid">
          <div className="field mb-4 col-12 md:col-6">
            <label htmlFor="registration_start" className="font-medium text-900">Début des inscriptions</label>
            <Calendar locale="fr" value={registrationStartDate !== "" ? new Date(registrationStartDate) : ""} onChange={(e) => {
              setRegistrationStartDate(e.value || "")

            }} dateFormat="dd/mm/yy" id="registration_start" showIcon />
          </div>
          <div className="field mb-4 col-12 md:col-6">
            <label htmlFor="registration_end" className="font-medium text-900">Fin des inscriptions</label>
            <Calendar locale="fr" value={registrationEndDate ? new Date(registrationEndDate) : ""} onChange={(e) => setRegistrationEndDate(e.value)} dateFormat="dd/mm/yy" id="registration_end" showIcon />
          </div>
          <div className="field mb-4 col-12 md:col-6">
            <label htmlFor="training_start" className="font-medium text-900">Début des cours</label>
            <Calendar locale="fr" value={trainingStartDate ? new Date(trainingStartDate) : ""} onChange={(e) => setTrainingStartDate(e.value || "")} dateFormat="dd/mm/yy" id="training_start" showIcon />
          </div>
          <div className="field mb-4 col-12 md:col-6">
            <label htmlFor="training_end" className="font-medium text-900">Fin des cours</label>
            <Calendar locale="fr" value={trainingEndDate ? new Date(trainingEndDate) : ""} onChange={(e) => setTrainingEndDate(e.value)} dateFormat="dd/mm/yy" id="training_end" showIcon />
          </div>
        </div>
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Règles intérieures de l'école/formation (URL)
        </label>
        <InputText
          id="internal_rules"
          type="text"
          value={internalRulesUrl}
          onChange={(e) => setInternalRulesUrl(e.target.value)}
          className="w-full mb-3"
        />
      </MeaUpdateModal >
    </>
  );
});

export default UpdateTrainingModal;
